import { serviceBase } from "../../../service";

const Tariff = {
  ...serviceBase,
  resource: "tariffs",
  preList: function(params) {
    delete params.id;
    const projectId = extractProjectIdFromUrl() || "-";
    return `projects/${params.project_id || projectId}`;
  },
  preListOption: {
    getList: true,
    get: true,
    create: true,
    update: true,
    delete: true,
    deleteList: true
  }
};
export default Tariff;
function extractProjectIdFromUrl() {
  const urlPath = window.location.pathname;
  const pathSegments = urlPath.split("/");
  const projectIndex = pathSegments.indexOf("projects") + 1;
  return pathSegments[projectIndex] || null;
}
